<template>
    <div class="slim">
        <slot></slot>
    </div>
</template>

<script>
import Slim from "./slim.module.js"

var instance = null

export default {
    props: ["options", "submitPressed"],
    name: "SlimCropper",
    watch: {
        submitPressed(newVal, oldVal) {
            $(".slim-btn-upload").each(function () {
                $(this).click()
            })

            this.$emit("upload")
        },
    },
    mounted: function () {
        if (this.options.initialImage) {
            var img = document.createElement("img")
            img.setAttribute("alt", "")
            img.src = this.options.initialImage
            this.$el.appendChild(img)
        }
        instance = new Slim(this.$el, this.options)
    },
    beforeDestroy: function () {
        instance.destroy()
    },
}
</script>
<style lang="css">
@import "./slim.css";
</style>
